/*
 * Created Date: 16-01-2024, 10:20:57 am
 * Author: Victor
 * Email: victor@pt-corp.vn
 * -----
 * Last Modified: Thu Jan 25 2024
 * Modified By: Victor
 * -----
 * Copyright (c) 2024 PT CORP, Inc
 * -----
 * HISTORY:
 * Date      	By	Comments
 * ----------	---	----------------------------------------------------------
 */

import React from 'react'
import { ROUTER_SUBCRIPTION } from './const'

const PlanLazy = React.lazy(() => import('../../Workspace/Plan/pages/SelectPlan'))

export const SubcriptionRouterConfig = {
	auth: ['admin'],
	settings: {
		layout: {
			config: {}
		}
	},
	routes: [
		// {
		// 	path: ROUTER_SUBCRIPTION.plan,
		// 	element: <PlanLazy />,
		// 	exact: true
		// },
		{
			path: ROUTER_SUBCRIPTION.plan,
			element: <PlanLazy />,
			exact: true
		}
	]
}
